// https://github.com/pinojs/pino
import pino from 'pino';

export const logger = pino({ browser: { serialize: true } });
